/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { Loader, numericPercentages, numericPixels } from "@packages/ui";

const loadingContainer: Interpolation = {
  display: "flex",
  justifyContent: "center",
  marginTop: numericPixels[96],
  width: numericPercentages[100],
};

export const LoadingPage = () => {
  return (
    <div css={loadingContainer}>
      <Loader />
    </div>
  );
};
